import React, { Component } from 'react';
import {Link} from 'react-router-dom';


function Kontakt () {

    return(
     <div className="mainContentWrapper">
    
                <div className="contentContainer">
                    
                    <div className="contentColumns">
                        <div className="landingleft slideInLeft marginHundred">
                            
                           <div className="sloganWhite slideInRight">
                                info@sys-team.de
                            </div>
                            
                        </div>
                        <div className="landingright slideInRight marginHundred">
                            <div className="sloganWhite slideInLeft">
                                            +49 (0) 6172 8557810
                                        </div>
                        </div>
    
                    </div>
    
                   
                
    
                  
    
    
                </div>
    
               
    
            </div>
     )       

}

export default Kontakt;